import PropTypes from "prop-types";
import BaseFormItem from "../BaseFormItem";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import userStore from "data/userStore";
import React from "react";
import Control from "lib/common/descriptorcontrols/FileField/rfpi";
import { buildFileMeta } from "data/selectors/fileUploads";
import FileUploadStore from "data/FileUploadStore";
import TableStore from "data/TableStore";
import Select from "lib/common/descriptorcontrols/BaseControls/Select";
import classNames from "classnames";
import useFluxStore from "@armus/use-flux-store";

export class FileFieldrfpi extends BaseFormItem {
    constructor(props) {
        super(props);

        this.state = {
            comparison: undefined,
            mode: "individual",
        };

        this.onCommitChange = this.onCommitChange.bind(this);
        this.onClick = this.onClick.bind(this);
        this.comparisons = {};
    }

    onCommitChange(d, v) {
        this.setState({
            comparison: v
        });
    }

    onClick(e) {
        e.preventDefault();
        this.setState({
            comparison: e.target.value === "individual" ? undefined : this.state.comparison,
            mode: e.target.value
        });
    }

    gatherComparisons(activeRecord) {
        const {
            entityInfo,
            id
        } = activeRecord.get("parent");

        const patientID = TableStore.getRecordData(entityInfo.tableKey, id).data.patient_id;
        const comparisonIDs = TableStore.getRecordData("patient", patientID).data.comparisons_id;
        const result = [{
            label: "Select a comparison",
            value: ""
        }];
        comparisonIDs.forEach(compId => {
            const x = TableStore.getRecordData("rfpi_imaging_comparison", compId).data;
            // TODO: fix labels (i.e.: use toString script)
            //  Barney thinks both invocations of `entityInfo.scripts.toString`,
            //  should instead be `activeRecord.getLabel()`? Maybe? They aren't
            //  going to do anything useful as-written, at least.
            if (x.episode_one_id === activeRecord.id) {
                result.push({
                    label: `${entityInfo.scripts.toString()} - Episode ${x.episode_two_id}`,
                    value: compId
                });
                this.comparisons[compId] = x;
            }
            if (x.episode_two_id === activeRecord.id) {
                result.push({
                    label: `${entityInfo.scripts.toString()} - Episode ${x.episode_one_id}`,
                    value: compId
                });
                this.comparisons[compId] = x;
            }

        });
        return result;
    }

    render() {
        const {
            activeRecord,
            descriptor
        } = this.props;
        const comparisons = this.gatherComparisons(activeRecord);

        const btnClasses = ["btn", "btn-toggle"];
        const individual = classNames(btnClasses, {
            "individual": this.state.mode === "individual"
        });
        const comparison = classNames(btnClasses, {
            "comparison": this.state.mode === "comparison"
        });

        const Selector = props => (
            <div className="mode-selector">
                <button className={individual} value="individual" onClick={this.onClick}>
                    Individual
                </button>
                <button className={comparison} value="comparison" onClick={this.onClick}>
                    Comparison
                </button>
            </div>
        );

        // TODO: this is quite hacky and it's here because of the related
        // IT test. needs clean up.
        const Dropdown = props => (
            <div
              className="dropdown-container control-container-comparisonselector"
              data-control-type="dropdown">
                <Select
                    {...props}
                    onCommitChange={this.onCommitChange}
                    value={this.state.comparison}
                    enabled={true}
                />
            </div>
        );

        let dropdown, selector;
        if (! _.isEmpty(comparisons)) {
            dropdown = <Dropdown options={comparisons} />;
            selector = <Selector/>;
        }

        const org = userStore.getActiveOrgKey();

        let imageFile;
        if (activeRecord.get("imagefile")) {
            imageFile = buildFileMeta(
                descriptor.key,
                activeRecord.id,
                org,
                activeRecord.entityKey,
                false,
                activeRecord.get("imagefile")
            );
        }

        let selectedComparisons;
        if (this.state.comparison) {
            const one = buildFileMeta(
                "imagefile_one",
                this.state.comparison,
                org,
                "rfpi/1-0/comparison",
                false,
                this.comparisons[this.state.comparison].imagefile_one_id
            );
            const two = buildFileMeta(
                "imagefile_two",
                this.state.comparison,
                org,
                "rfpi/1-0/comparison",
                false,
                this.comparisons[this.state.comparison].imagefile_two_id
            );

            if (this.comparisons[this.state.comparison].episode_one_id === activeRecord.id) {
                selectedComparisons = [one, two];
            } else {
                selectedComparisons = [two, one];
            }
        }


        return (
              <ConnectedControl {...this.getPlumbingProps()}
                      onClick={this.onClick}
                      value={activeRecord.get(descriptor.key)}
                      enabled={activeRecord.isFieldEnabled(descriptor.key)}
                      imageFile={imageFile}
                      selectedComparisons={selectedComparisons}
                      dropdown={dropdown}
                      selector={selector}
                      mode={this.state.mode}
              />
        );
    }
}

const ConnectedControl = props => {
    const state = useFluxStore(() => ({}), [
        FileUploadStore,
    ], [props]);
    return <Control {...props} {...state} />;
};

FileFieldrfpi.propTypes = {
    descriptor: PropTypes.shape(descriptorPropTypes())
};

export default FileFieldrfpi;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/FileField/rfpi.js